import React from "react";
import styled from "styled-components";

function ImageProdcut() {
  return <ImageProdcutStyle>ImageProdcut</ImageProdcutStyle>;
}

const ImageProdcutStyle = styled.div`
  background-color: ${({ theme }) => theme.backgroundSidebar};
`;

export default ImageProdcut;
